import { notEmpty } from './formats';

// Receive initials from a name

export const getInitials = (s?: string) =>
  s
    ?.split(' ')
    .slice(0, 2)
    .filter(notEmpty)
    .map((x) => x?.[0]?.toUpperCase())
    .join('');
